
export const getSurveyCategoryTypes = () => {
  return [...SurveyCategoryTypes]
};

export const SurveyCategoryTypes = [
  { id: '1', label: 'Benefits' },
  { id: '2', label: 'Exit' },
  { id: '10', label: 'Form/Application' },
  { id: '3', label: 'Onboarding/New Hire' },
  { id: '4', label: 'Poll/Opinion' },
  { id: '5', label: 'Pulse/Engagement' },
  { id: '6', label: 'Stay' },
  { id: '7', label: 'Training Feedback' },
  { id: '8', label: 'Wellness' },
  { id: '9', label: 'Other...' },
];
